import { AfterViewInit, Component, Inject, OnDestroy, OnInit, Type, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { HotAlert } from 'src/app/modules/pages/hot-alert/configurations/hot-alert';
import { ClosedLoop } from 'src/app/modules/pages/interview-summary/models/closed-loop';
import { InterviewSummary } from 'src/app/modules/pages/interview-summary/models/interview-summary';
import { SurveyService } from 'src/app/services/survey.service';
import { DownloadExcelCommand } from '../../commands/download-excel-command';
import { InterviewDetail } from '../table-links-modal/models/interview-details';
import { InterviewsV2Service, QuestionModel } from 'src/app/services/interviews-v2.service';
import { MyUtils } from 'src/app/services/my-utils.service';
import { ApplicationService } from 'src/app/services/application.service';
import { InterviewDetailsMapper } from '../interview-detail/interview-detail-mapper.service';
import { FormControl, FormGroup } from '@angular/forms';

import { Appeal } from "src/app/modules/pages/hot-alert/configurations/appeal";
import { ActionButtonsComponent } from '../../table-components/action-buttons/action-buttons.component';
import { ActionCol } from '../../table-col-configs/action-col';
import { DownloadPDFCommand } from '../../commands/download-pdf-command';
import { TableStructure } from 'src/app/modules/records/models/table-structure';
import { IPayload } from 'src/app/interface/filters';
interface DetailSection {
    data: Record<string, string>,
    icon: string,
    title: string,
}
@Component({
    selector: 'app-interview-detail-v2',
    templateUrl: './interview-detail-v2.component.html',
    styleUrls: ['./interview-detail-v2.component.scss'],
})
export class InterviewDetailV2Component implements OnInit, AfterViewInit, OnDestroy {
    @ViewChild(ActionButtonsComponent)
    actionButtonsComponent?: ActionButtonsComponent<InterviewDetail>;
    subscription?: Subscription;
    surveyModel: QuestionModel[];
    actions: DownloadExcelCommand<InterviewDetail, SurveyService>[];
    isCEC: Boolean = false;
    interviewDetail: InterviewDetail;
    mappedData: DetailSection[] = [];
    answerQuestions: any = [];
    cecVerbatim: any;
    isAppeal: Boolean = false;
    showDataMining: Boolean = false;
    dataMiningForm: FormGroup | null = null;
    showInterview: boolean = true;
    appeal: any;
    singleAppeal;
    tableConfig: TableStructure<any> = new TableStructure<any>([], "clientSide");
    loading = false;


    constructor(
        @Inject(MAT_DIALOG_DATA) public interviewData: InterviewSummary | HotAlert | ClosedLoop,
        private surveyService: SurveyService,
        private interviewService: InterviewsV2Service,
        public utils: MyUtils,
        private applicationService: ApplicationService,
        private mapper: InterviewDetailsMapper,

        public dialogRef?: MatDialogRef<InterviewDetailV2Component>

    ) {
        this.actions = [new DownloadExcelCommand(this.surveyService)];
        this.surveyModel = this.interviewService.currentQuestionModel.value;
        this.isCEC = this.applicationService.navBarSelectValue?.idItem.includes('CEC') ?? false;
        this.interviewDetail = new InterviewDetail({ ...interviewData, toMap: true });
        this.singleAppeal = new Appeal(this.interviewDetail);

    }
    ngAfterViewInit(): void {
        console.log("isCEC", this.isCEC);
        this.actionButtonsComponent?.setComponentData(
            this.interviewDetail,
            new ActionCol<InterviewDetail, Type<ActionButtonsComponent<InterviewDetail>>, any>(
                "surveyRequestId",
                false,
                undefined,
                [new DownloadExcelCommand<InterviewDetail, SurveyService>(this.surveyService, !this.isCEC ? true : undefined), new DownloadPDFCommand<InterviewDetail, SurveyService>(this.surveyService)],
                ActionButtonsComponent
            )
        );
    }
    ngOnInit(): void {

        if (this.interviewData.hasOwnProperty('downloadDetail') && (this.interviewData as InterviewSummary).downloadDetail) {
            const filter: IPayload = this.utils.settingsPayloadValue.payload;
            const extraFilters: any = {
                searchBy: "surveyRequestId",
                searchFor: (this.interviewData as InterviewSummary).surveyRequestId,
                NPS: "",
                NSAT: "",
                recovery: "",
                channel: ""
            }

            this.loading = true;
            this.interviewService.getAll(
                filter,
                0,
                1,
                "ASC",
                "surveyRequestId",
                extraFilters,
                this.tableConfig,
                true
            ).subscribe((res) => {
                this.interviewDetail = new InterviewDetail(res.items[0]);

                this.initDetails();
                if (this.isCEC && !!this.interviewDetail.surveyRequestId) {
                    this.getDataMiningData();
                }

                this.loading = false;
            });
        }
        else {
            this.initDetails();
            if (this.isCEC && !!this.interviewDetail.surveyRequestId) {
                this.getDataMiningData();
            }

        }

    }

    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }

    private initDetails() {
        const details = this.isCEC ? this.mapper.mapCecInterviewDetails(this.interviewDetail) : this.mapper.mapInterviewDetails(this.interviewDetail)

        let ids = this.interviewService.idTableValue ?? [];

        ids.push(this.interviewDetail.surveyRequestId);
        this.interviewService.setIdsTableValue(ids);

        this.mappedData = [
            {
                data: details.get('customerData')!,
                icon: "perm_identity",
                title: "CustomerDetails",
            },
            {
                data: details.get('vehicleData')!,
                icon: "directions_car",
                title: "vehicle_details",
            },
            {
                data: details.get('surveyData')!,
                icon: "event_note",
                title: "surveyDetails",
            },
        ];

        if (this.isCEC) {
            this.mappedData.push({
                data: details.get('caseData')!,
                icon: "event_note",
                title: "Case Details",
            })
        }
        this.answerQuestions = this.surveyModel.filter(el => !(el.questionType === 'FreeTextLarge' && this.isCEC)).map(el => {
            let answer = this.interviewDetail[el.questionCode as keyof InterviewDetail];
            return {
                question: el.questionLabel,
                answer
            }
        }).filter(el => el.answer);
        let verbatim = this.surveyModel.find(el => (el.questionType === 'FreeTextLarge' && this.isCEC))
        if (verbatim) {
            let answer = this.interviewDetail[verbatim.questionCode as keyof InterviewDetail];
            this.cecVerbatim = {
                question: verbatim.questionLabel,
                answer
            }
        }
    }
    getLabels(object: Record<string, string>): string[] {
        return Object.keys(object);
    }
    getDataMiningData() {
        let data: any = this.interviewDetail;
        if (data?.mined) {
            this.showDataMining = true;
            this.dataMiningForm = new FormGroup({
                contactReasonL1: new FormControl(data.contactReasonL1),
                contactReasonL2: new FormControl(data.contactReasonL2),
                dissatisfacionReason1Level1: new FormControl(data.dissatisfacionReason1Level1),
                dissatisfacionReason1Level2: new FormControl(data.dissatisfacionReason1Level2),
                dissatisfacionReason2Level1: new FormControl(data.dissatisfacionReason2Level1),
                dissatisfacionReason2Level2: new FormControl(data.dissatisfacionReason2Level2),
                personEnteringInfo: new FormControl(data.personEnteringInfo),
                description: new FormControl(data.rpDescription),
                dtStart: new FormControl(new Date(data.rpStartDate))
            })
            this.dataMiningForm.disable()
        }
    }
    clickShowInterview() {
        this.showInterview = !this.showInterview;
    }






}
